import { render, staticRenderFns } from "./BSFQv2.vue?vue&type=template&id=36f1c385&scoped=true"
import script from "./BSFQv2.vue?vue&type=script&lang=js"
export * from "./BSFQv2.vue?vue&type=script&lang=js"
import style0 from "./BSFQv2.vue?vue&type=style&index=0&id=36f1c385&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f1c385",
  null
  
)

export default component.exports